// src/pages/consult/Stepper.js
import React from 'react'
import { Check } from 'lucide-react'   // ícone de check
import styles from './consult.module.css'

/**
 * totalSteps: número total de círculos
 * currentStep: passo atual (1-based)
 */
const Stepper = ({ totalSteps, currentStep }) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1)
  return (
    <div className={styles.stepper}>
      {steps.map((num, idx) => {
        const isCompleted = num < currentStep
        const isActive    = num === currentStep

        return (
          <div key={num} className={styles.stepWrapper}>
            <div
              className={[
                styles.stepCircle,
                isCompleted && styles.completed,
                isActive    && styles.active
              ]
                .filter(Boolean)
                .join(' ')
              }
            >
              {isCompleted
                ? <Check size={16}/>
                : String(num).padStart(2, '0')
              }
            </div>
            {idx < steps.length - 1 && (
              <div className={styles.stepLine} />
            )}
          </div>
        )
      })}
    </div>
  )
}

export default Stepper
